export class OtpModel {

    DETAIL_NO: string;

    OTP: string;

    OTP_SMS: string;

    PATIENTID: string;

    MOBILENO: string;
    OTP_STATUS: string;
    NORMALORKIOSK: string;
    USERIDM: string;
    USERIDC: string;
    TRANSACTIONFROMTYPE: string;
    TRANSACTIONFROMNO: string;
    CIVILID: string;
    TimeCounter: string;
    VERIFIED: string;
    ENTEREDOTP: string;
    FIRST_NAME: string;
    MIDDLE_NAME: string;
    LAST_NAME: string;
    EMAIL: string;
    REGISTERCOUNT: string;
    REGISTERNO: string;
    DummyMobileNumber: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/ServicePayment/OtpModel.ts